import { API_ENDPOINTS } from './api-endpoints';

export const environmentDefaults = {
  DESKING: API_ENDPOINTS.DESKING.TEST,
  production: false,
  hostname: API_ENDPOINTS.HOSTNAME.TEST,
  ENV: API_ENDPOINTS.ENV.TEST, //(PROD || TEST || QA || E2E || STAGE) ? JSON.stringify('production') : JSON.stringify('development'), 
  /**
  * specifies which @ngrx dev tools will be available when you build and load
  * your app in dev mode. Options are: monitor | logger | both | none
  */
  STORE_DEV_TOOLS: API_ENDPOINTS.STORE_DEV_TOOLS.TEST,
  MIN_LOG_LEVEL: API_ENDPOINTS.MIN_LOG_LEVEL.TEST,
  ACTUAL_ENV: API_ENDPOINTS.ACTUAL_ENV.TEST,  //  PROD ? JSON.stringify('production') : QA ? JSON.stringify('qa') : TEST ? JSON.stringify('test') : E2E ? JSON.stringify('e2e') : STAGE ? JSON.stringify('stage') : JSON.stringify('development'),
  EFC_URL: API_ENDPOINTS.EFC_URL.TEST,
  AUTH_BASE_URL: API_ENDPOINTS.AUTH_BASE_URL.TEST,
  DIS_URL: API_ENDPOINTS.DIS_URL.TEST,
  BASE_SERVICE_URL: API_ENDPOINTS.BASE_SERVICE_URL.TEST,
  PRESOLD_BASE_SERVICE_URL: API_ENDPOINTS.PRESOLD_BASE_SERVICE_URL.TEST,
  USED_VEHICLE_BASE_SERVICE_URL: API_ENDPOINTS.USED_VEHICLE_BASE_SERVICE_URL.TEST,
  POST_LOGOUT_REDIRECT_URL: API_ENDPOINTS.POST_LOGOUT_REDIRECT_URL.TEST,
  SILENT_REDIRECT_URL: API_ENDPOINTS.SILENT_REDIRECT_URL.TEST,
  AUTHORIZATION_ENDPOINT: API_ENDPOINTS.AUTHORIZATION_ENDPOINT.TEST,
  ISSUER: API_ENDPOINTS.ISSUER.TEST,
  JWTURI: API_ENDPOINTS.JWTURI.TEST,
  AUTHORITY: API_ENDPOINTS.AUTHORIZATION_ENDPOINT.TEST,
  CLIENT_ID: API_ENDPOINTS.CLIENT_ID.TEST,
  CONSUMER_PREVIEW_ENDPOINT: API_ENDPOINTS.CONSUMER_PREVIEW_ENDPOINT.TEST,
  MST_BASE_SERVICE_URL: API_ENDPOINTS.MST_BASE_SERVICE_URL.TEST,
  DG_BASE_SERVICE_URL: API_ENDPOINTS.DG_BASE_SERVICE_URL.TEST,
  SOCKET_ENDPOINT: API_ENDPOINTS.SOCKET_ENDPOINT.TEST,
  VSPEC_GUEST_PORTAL: API_ENDPOINTS.VSPEC_GUEST_PORTAL.TEST,
  CREDIT_APP_URL: API_ENDPOINTS.CREDIT_APP_URL.TEST,
  ENGAGE_MATERIAL_URL: API_ENDPOINTS.ENGAGE_MATERIAL_URL.TEST,
  MST_CONSOLE: API_ENDPOINTS.MST_CONSOLE.TEST,
  AUTH_AUTHORITY: API_ENDPOINTS.AUTH_AUTHORITY.TEST,
  SIGNAL_URL: API_ENDPOINTS.SIGNAL.TEST,
  TRADE_SIGNAL_URL: API_ENDPOINTS.TRADE_SIGNAL_ENDPOINT.TEST
};